import { render, staticRenderFns } from "./dragdropBox.vue?vue&type=template&id=0845f812&scoped=true&"
import script from "./dragdropBox.vue?vue&type=script&lang=js&"
export * from "./dragdropBox.vue?vue&type=script&lang=js&"
import style0 from "./dragdropBox.vue?vue&type=style&index=0&id=0845f812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0845f812",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardActions,VIcon,VSpacer,VTextarea})
